var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$.context_menus_wrapper },
    _vm._l(_vm.contextMenus, function (context) {
      return _c("context-menu", {
        key: "context_menu_" + context.type + "_" + context.menu,
        class: [
          _vm.$.context_menu,
          _vm.isMultiselectContext(context) ? "" : "gantt_scroll",
        ],
        style: _vm.getPopupStyle(context),
        attrs: {
          boundaryElementSelector: ".board_main_container",
          position: context.position,
          side: context.side,
          "data-menu-type": context.type + ":" + context.menu,
        },
        on: {
          onClickOutside: function (e) {
            return _vm.handleClosePopup(context, e)
          },
          scroll: function () {
            return _vm.handleClosePopup(context)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "body",
              fn: function () {
                return [
                  _vm.isMultiselectContext(context)
                    ? _c("MultiselectContextMenu", {
                        attrs: { items: _vm.getMenuItems(context) },
                        on: {
                          selectItems: function (values) {
                            return _vm.selectedMultiselect(values, context)
                          },
                        },
                      })
                    : _c(
                        "div",
                        { class: ["gantt_scroll"] },
                        _vm._l(_vm.getMenuItems(context), function (item) {
                          return _c(
                            "div",
                            _vm._g(
                              {
                                class: [
                                  _vm.$.menu_item,
                                  item.selected &&
                                  !(
                                    item.isMultiselect && item.value !== "empty"
                                  )
                                    ? _vm.$.selected
                                    : "",
                                  item.selected ? "selected_menu_item" : "",
                                  item.disabled ? _vm.$.disabled : "",
                                  item.divider ? _vm.$.divider : "",
                                ],
                                attrs: {
                                  "data-menu-type": item.type + ":" + item.menu,
                                },
                              },
                              _vm.mouseHandlers(context, item)
                            ),
                            [
                              item.divider
                                ? _c("div", { class: _vm.$.divider }, [
                                    item.name
                                      ? _c(
                                          "div",
                                          { class: _vm.$.divider__label },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(item.name) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { class: _vm.$.divider__line }),
                                  ])
                                : _c("div", { class: _vm.$.item_content }, [
                                    item.isMultiselect && item.value !== "empty"
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              _vm.$.checkbox,
                                              item.selected
                                                ? _vm.$.selected
                                                : "",
                                            ],
                                          },
                                          [
                                            _c("svg-sprite", {
                                              style: { color: "#FFFFFF" },
                                              attrs: {
                                                name: "check",
                                                type: "regular",
                                                size: 16,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.icon
                                      ? _c(
                                          "div",
                                          {
                                            class: _vm.$.icon,
                                            style: {
                                              background: item.isColorField
                                                ? item.name
                                                : "",
                                            },
                                          },
                                          [
                                            item.iconType === "img"
                                              ? _c("img", {
                                                  attrs: { src: item.icon },
                                                })
                                              : _c("svg-sprite", {
                                                  style: {
                                                    color: item.iconColor || "",
                                                  },
                                                  attrs: {
                                                    name: item.icon,
                                                    type: item.iconType,
                                                    size: item.iconSize,
                                                  },
                                                }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !item.isColorField
                                      ? _c(
                                          "div",
                                          {
                                            class: [
                                              _vm.$.label,
                                              item.labelBg
                                                ? _vm.$.is_label_field
                                                : "",
                                            ],
                                            style: {
                                              color: item.labelColor || "",
                                              background: item.labelBg || "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(item.name) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.iconRight
                                      ? _c(
                                          "div",
                                          { class: _vm.$.icon_right },
                                          [
                                            _c("svg-sprite", {
                                              style: {
                                                color: item.iconRightColor
                                                  ? item.iconRightColor
                                                  : "",
                                              },
                                              attrs: {
                                                name: item.iconRight,
                                                type: item.iconRightType,
                                                size: item.iconRightSize,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]),
                            ]
                          )
                        }),
                        0
                      ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }